/**
 * Achievements page
 */
class Achievements {
    constructor() {
        $('div.multiple', 'section.achievements').each(function() {
        	var achievements = $('div.achievement', this);
        	var arrow = $('nav > div', this);
        	var buttons = $('nav > a', this);
        	var open = -1;

        	buttons.each(function(ind) {
        		$(this).click(function() {
        			return false;
        		});

        		$(this).mouseover(function() {
        			achievements.css('display', 'none');
        			achievements.eq(ind).css('display', 'block');
        			arrow.css('left', $(this).position().left);
        		});
        	});

        	achievements.each(function(ind) {
        		var target = $('span.target', this);
        		switch(target.text().length) {
        			case 3: target.addClass('small'); break;
        			case 4: target.addClass('x-small'); break;
        		}

        		if($(this).hasClass('gained')) {
        			buttons.eq(ind).addClass('gained');
        			open = (ind < 5) ? ind + 1 : ind;
        		}
        	});

        	if(open >= 0) buttons.eq(open).mouseover();
        });

        $('div.container').addClass('low');
    }
};

export { Achievements };
